import { create } from "zustand";
import { SaleOrder } from "types";

type SaleOrderState = {
  rows: SaleOrder[];
  isLoading: boolean;
  setRows: (rows: SaleOrder[]) => void;
  upsertRow: (row: SaleOrder) => void;
  removeRow: (id: number | string) => void;
  setLoading: (loading: boolean) => void;
  reset: () => void;
};

export const useSaleOrderStore = create<SaleOrderState>()((set) => ({
  rows: [],
  isLoading: false,
  setRows: (rows) => set({ rows: rows || [] }),
  upsertRow: (row) =>
    set((state) => {
      const exists = state.rows.find((item) => item.id === row.id);
      const rows = exists
        ? state.rows.map((item) =>
            item.id === row.id ? { ...item, ...row } : item,
          )
        : [row, ...state.rows];
      return { rows };
    }),
  removeRow: (id) =>
    set((state) => ({
      rows: state.rows.filter((item) => String(item.id) !== String(id)),
    })),
  setLoading: (loading) => set({ isLoading: loading }),
  reset: () => set({ rows: [], isLoading: false }),
}));
